import { gql } from 'graphql-request';
import type { CurrencyISO } from '@/constants/currencies';

type PortfolioType = 'linked' | 'manual';

interface HoldingFragmentType {
  companyId: string;
  isAnalysisRestricted: boolean;
}

interface Link {
  brokerageName: string;
}

export interface PortfoliosFragmentType {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  type: PortfolioType;
  manualInputOption: string;
  link: Link;
  currencyISO: CurrencyISO;
  holdings: HoldingFragmentType[];
  isAnalysisRestricted: boolean;
}

export const HOLDING_FRAGMENT = gql`
  fragment holdingFields on Holding {
    companyId
    isAnalysisRestricted
  }
`;

export const PORTFOLIOS_FRAGMENT = gql`
  fragment portfolioFields on Portfolio {
    id
    name
    createdAt
    currencyISO
    updatedAt
    type
    manualInputOption
    isAnalysisRestricted
    link {
      brokerageName
    }
    holdings {
      ...holdingFields
    }
  }
  ${HOLDING_FRAGMENT}
`;
